import React from "react";
import Clients from "../../components/Clients";
import Cta from "../../components/Cta";
import Footer from "../../components/Footer";
import MainPageBanner from "./MainPageBanner";
import AboutUs from "../../components/AboutUs";
import Services from "../../components/Services";
import Contacts from "../../components/Contacts";
import {useDocTitle} from "../../components/CustomHook";

const HomePage = () => {
    useDocTitle('M&rivet, s.r.o. - Predaj elektrického náradia a rezanie materiálov vodným lúčom')
    return (
        <>
            <MainPageBanner/>
            <AboutUs/>
            <Services/>
            {/*<Clients/>*/}
            <Contacts/>
            <Cta/>
            <Footer/>
        </>
    );
};

export default HomePage;
